// extracted by mini-css-extract-plugin
module.exports = {"fadeOut":"xi","a":"xj"};